module.exports = "/_next/static/images/LovedBy10MillionDevelopers@2x-aced453c09ef3fb7b5d1a974674e7a28.png";